export default __webpack_public_path__ + "static/media/Photo 12 - BR - Façade protégée.db5d187c.png";